import React from 'react';
import { ScanSearchIcon, WrenchIcon, ClipboardCheckIcon } from 'lucide-react';
import { expertiseRows } from '../data/homepage';
const icons = {
  stand: ScanSearchIcon,
  improve: WrenchIcon,
  changed: ClipboardCheckIcon
} as const;
export function ExpertiseSection() {
  return <section aria-labelledby="expertise-title" className="bg-mint" data-id="element-58" data-mp="1dilwh7mtzrta">
      <div className="mx-auto grid max-w-[1280px] gap-8 px-5 py-12 md:gap-10 md:px-8 md:py-16 lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)] lg:gap-20 lg:py-20" data-id="element-59" data-mp="1dkf4aq96ki2v">
        <div data-id="element-60" data-mp="kuq3acwh0i19">
          <h2 id="expertise-title" className="max-w-[520px] text-[30px] font-extrabold leading-[1.12] text-ink md:text-[42px]" data-id="element-61" data-mp="kuyc9tph3376">
            Our experience leads. AI moves the work forward.
          </h2>
          <p className="mt-5 max-w-[500px] text-[17px] leading-[1.6] text-ink/85" data-id="element-62" data-mp="uu72qcl4pzos">
            AI helps us research deeper, build faster, and make more improvements. Our experienced team
            sets the priorities, reviews the work, and makes the final decisions.
          </p>
          <p className="mt-4 max-w-[500px] text-[17px] font-semibold leading-[1.6] text-ink" data-id="element-63" data-mp="74cbvtlbw8xx">
            SEO, content, Google Ads, and social advertising work toward the same business goals.
          </p>
        </div>

        <ul className="border-t border-mint-line" data-id="element-64" data-mp="l20ueurxb3zt">
          {expertiseRows.map(row => {
          const Icon = icons[row.id as keyof typeof icons];
          return <li key={row.id} className="grid grid-cols-[28px_1fr] gap-x-5 border-b border-mint-line py-6 sm:grid-cols-[28px_minmax(0,220px)_1fr] sm:gap-x-6" data-id="element-65" data-mp="3kf1l7asq0bt5">
                <Icon className="mt-0.5 h-6 w-6 text-brand-greenDeep" strokeWidth={1.75} aria-hidden data-id="element-66" data-mp="3tfzr5ympyted" />
                <h3 className="text-[18px] font-bold leading-snug text-ink" data-id="element-67" data-mp="24zrdfhxjdyi">{row.title}</h3>
                <p className="col-start-2 mt-2 text-[16px] leading-[1.6] text-ink/85 sm:col-start-3 sm:mt-0" data-id="element-68" data-mp="31ok3s2dc92n3">
                  {row.body}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}